export const appConfig = {
  hostUrl: 'http://localhost:6001',
  //hostRealUrl: 'https://price123.house123.com.tw',
  hostRealUrl: 'https://price123.house123.com.tw',
  debug: false,
  //googleMapApiKey: 'AIzaSyAyOBjhFipWAg2B-SqyfDDxCibhO_Oss-s',
  //googleMapApiKey: 'AIzaSyCEo8MhGG-KMaBtszAZnsjMZP8Xx_FulXQ',
  // googleMapApiKey: 'AIzaSyAsHUdH4YxhK-HzMsCFE9auV4-itFAg08k',
  googleMapApiKey: 'AIzaSyAu8Ioc9ZocqXCiPy2baKWM8vC2Utap77U',
}
